import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import DataTable from "../../common/DataTable";
import { buildSearchListColumns } from "./searchColumns";

const SearchList = ({ data, meta, loading, isImsi, client, operation, ...props }) => {
  const nav = useNavigate();
  const columns = useMemo(
    () => buildSearchListColumns({ operation, client, isImsi }),
    [operation, client, isImsi]
  );

  return (
    <DataTable
      handleRowClick={(params) => nav(`batch/${params.row.batch_id}`)}
      disableColumnFilter
      loading={loading}
      data={data}
      columns={columns}
      metaData={meta}
      {...props}
    />
  );
};

export default SearchList;
